import React from 'react';
import Bar from './JSX/Bar';
import Footer from './JSX/Footer';

const MainPage = () => {
    return (
        <div>

  <Bar/>
  <section
    id="hero-animated"
    className="hero-animated d-flex align-items-center"
  >
    <div
      className="container d-flex flex-column justify-content-center align-items-center text-center position-relative"
      data-aos="zoom-out"
    >
      <img
        src="./img/hero-carousel/hero-carousel-3.svg"
        className="img-fluid animated"
      />
      <h2>
        Welcome to <span>IPMS-PROJ</span>
      </h2>
      <p>
      Investment Project Management System.
      </p>
      <div className="d-flex">
        <a href="/Service" className="btn-get-started scrollto">
          Get Started
        </a>
        <a
          href="https://www.youtube.com/watch?v=LXb3EKWsInQ"
          className="glightbox btn-watch-video d-flex align-items-center"
        >
          <i className="bi bi-play-circle" />
          <span>Watch Video</span>
        </a>
      </div>
    </div>
  </section>
  <main id="main">

    {/* ======= Clients Section ======= */}
    <section id="clients" className="clients">
      <div className="container" data-aos="zoom-out">
        <div className="clients-slider swiper">
          <div className="swiper-wrapper align-items-center">
            <div className="swiper-slide">
              <img
                src="./img/clients/client-1.png"
                className="img-fluid"
                alt=""
              />
            </div>
            <div className="swiper-slide">
              <img
                src="./img/clients/client-2.png"
                className="img-fluid"
                alt=""
              />
            </div>
            <div className="swiper-slide">
              <img
                src="./img/clients/client-3.png"
                className="img-fluid"
                alt=""
              />
            </div>
            <div className="swiper-slide">
              <img
                src="./img/clients/client-4.png"
                className="img-fluid"
                alt=""
              />
            </div>
            <div className="swiper-slide">
              <img
                src="./img/clients/client-5.png"
                className="img-fluid"
                alt=""
              />
            </div>
            <div className="swiper-slide">
              <img
                src="./img/clients/client-6.png"
                className="img-fluid"
                alt=""
              />
            </div>
            <div className="swiper-slide">
              <img
                src="./img/clients/client-7.png"
                className="img-fluid"
                alt=""
              />
            </div>
            <div className="swiper-slide">
              <img
                src="./img/clients/client-8.png"
                className="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* End Clients Section */}

    {/* ======= On Focus Section ======= */}
    <section id="onfocus" className="onfocus">
      <div className="container-fluid p-0" data-aos="fade-up">
        <div className="row g-0">
          <div className="col-lg-6 video-play position-relative">
            <a
              href="https://www.youtube.com/watch?v=LXb3EKWsInQ"
              className="glightbox play-btn"
            />
          </div>
          <div className="col-lg-6">
            <div className="content d-flex flex-column justify-content-center h-100">
              <h3>How this Website Helps You !?</h3>
              <p className="fst-italic">
              The website helps new investors to manage their projects by providing many services.
              </p>
              <ul>
                <li>
                  <i className="bi bi-check-circle" /> Prefeasibility study for the target market.
                </li>
                <li>
                  <i className="bi bi-check-circle" /> Presenting potential investment projects.
                </li>
                <li>
                  <i className="bi bi-check-circle" /> Consulting services.
                </li>
                <li>
                  <i className="bi bi-check-circle" /> Prefeasibility study for Priceing.
                </li>
              </ul>
              <a href="#" className="read-more align-self-start">
                <span>Read More</span>
                <i className="bi bi-arrow-right" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* End On Focus Section */}

    {/* ======= Features Section ======= */}
    <section id="features" className="features">
      <div className="container" data-aos="fade-up">
        <ul className="nav nav-tabs row gy-4 d-flex">
          <li className="nav-item col-6 col-md-4 col-lg-2">
            <a
              className="nav-link active show"
              data-bs-toggle="tab"
              data-bs-target="#tab-1"
            >
              <i className="bi bi-clipboard2-data" />
              <h4>Prefeasibility</h4>
            </a>
          </li>
          {/* End Tab 1 Nav */}
          <li className="nav-item col-6 col-md-4 col-lg-2">
            <a
              className="nav-link"
              data-bs-toggle="tab"
              data-bs-target="#tab-2"
            >
              <i className="bi bi-building" />
              <h4>Undaesenti</h4>
            </a>
          </li>
          {/* End Tab 2 Nav */}
          <li className="nav-item col-6 col-md-4 col-lg-2">
            <a
              className="nav-link"
              data-bs-toggle="tab"
              data-bs-target="#tab-3"
            >
              <i className="bi bi-robot" />
              <h4>Pariatur</h4>
            </a>
          </li>
          {/* End Tab 3 Nav */}
          <li className="nav-item col-6 col-md-4 col-lg-2">
            <a
              className="nav-link"
              data-bs-toggle="tab"
              data-bs-target="#tab-4"
            >
              <i className="bi bi-pie-chart" />
              <h4>Nostrum</h4>
            </a>
          </li>
          {/* End Tab 4 Nav */}
          </ul>
        <div className="tab-content">
          <div className="tab-pane active show" id="tab-1">
            <div className="row gy-4">
              <div
                className="col-lg-8 order-2 order-lg-1"
                data-aos="fade-up"
                data-aos-delay={100}
              >
                <h3>Prefeasibility study for the target market</h3>
                <p className="fst-italic">
                The prefeasibility study helps the project owner to identify several important aspects and basics of the project, through which the possible and appropriate size of the project is determined, the appropriate geographical location is selected, and the appropriate production system is selected. investment project.
                </p>
                <ul>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Ullamco laboris
                    nisi ut aliquip ex ea commodo consequat.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Duis aute irure
                    dolor in reprehenderit in voluptate velit.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Ullamco laboris
                    nisi ut aliquip ex ea commodo consequat. Duis aute irure
                    dolor in reprehenderit in voluptate trideta storacalaperda
                    mastiro dolore eu fugiat nulla pariatur.
                  </li>
                </ul>
              </div>
              <div
                className="col-lg-4 order-1 order-lg-2 text-center"
                data-aos="fade-up"
                data-aos-delay={200}
              >
                <img
                  src="./img/features-1.svg"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          {/* End Tab Content 1 */}
          <div className="tab-pane" id="tab-2">
            <div className="row gy-4">
              <div className="col-lg-8 order-2 order-lg-1">
                <h3>Undaesenti</h3>
                <p>
                  Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis
                  aute irure dolor in reprehenderit in voluptate velit esse
                  cillum dolore eu fugiat nulla pariatur. Excepteur sint
                  occaecat cupidatat non proident, sunt in culpa qui officia
                  deserunt mollit anim id est laborum
                </p>
                <p className="fst-italic">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <ul>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Ullamco laboris
                    nisi ut aliquip ex ea commodo consequat.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Duis aute irure
                    dolor in reprehenderit in voluptate velit.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Provident mollitia
                    neque rerum asperiores dolores quos qui a. Ipsum neque dolor
                    voluptate nisi sed.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Ullamco laboris
                    nisi ut aliquip ex ea commodo consequat. Duis aute irure
                    dolor in reprehenderit in voluptate trideta storacalaperda
                    mastiro dolore eu fugiat nulla pariatur.
                  </li>
                </ul>
              </div>
              <div className="col-lg-4 order-1 order-lg-2 text-center">
                <img
                  src="./img/features-2.svg"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          {/* End Tab Content 2 */}
          <div className="tab-pane" id="tab-3">
            <div className="row gy-4">
              <div className="col-lg-8 order-2 order-lg-1">
                <h3>Pariatur</h3>
                <p>
                  Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis
                  aute irure dolor in reprehenderit in voluptate velit esse
                  cillum dolore eu fugiat nulla pariatur. Excepteur sint
                  occaecat cupidatat non proident, sunt in culpa qui officia
                  deserunt mollit anim id est laborum
                </p>
                <ul>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Ullamco laboris
                    nisi ut aliquip ex ea commodo consequat.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Duis aute irure
                    dolor in reprehenderit in voluptate velit.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Provident mollitia
                    neque rerum asperiores dolores quos qui a. Ipsum neque dolor
                    voluptate nisi sed.
                  </li>
                </ul>
                <p className="fst-italic">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
              </div>
              <div className="col-lg-4 order-1 order-lg-2 text-center">
                <img
                  src="./img/features-3.svg"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          {/* End Tab Content 3 */}
          <div className="tab-pane" id="tab-4">
            <div className="row gy-4">
              <div className="col-lg-8 order-2 order-lg-1">
                <h3>Nostrum</h3>
                <p>
                  Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis
                  aute irure dolor in reprehenderit in voluptate velit esse
                  cillum dolore eu fugiat nulla pariatur. Excepteur sint
                  occaecat cupidatat non proident, sunt in culpa qui officia
                  deserunt mollit anim id est laborum
                </p>
                <p className="fst-italic">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <ul>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Ullamco laboris
                    nisi ut aliquip ex ea commodo consequat.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Duis aute irure
                    dolor in reprehenderit in voluptate velit.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Ullamco laboris
                    nisi ut aliquip ex ea commodo consequat. Duis aute irure
                    dolor in reprehenderit in voluptate trideta storacalaperda
                    mastiro dolore eu fugiat nulla pariatur.
                  </li>
                </ul>
              </div>
              <div className="col-lg-4 order-1 order-lg-2 text-center">
                <img
                  src="./img/features-4.svg"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          {/* End Tab Content 4 */}
          <div className="tab-pane" id="tab-5">
            <div className="row gy-4">
              <div className="col-lg-8 order-2 order-lg-1">
                <h3>Adipiscing</h3>
                <p>
                  Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis
                  aute irure dolor in reprehenderit in voluptate velit esse
                  cillum dolore eu fugiat nulla pariatur. Excepteur sint
                  occaecat cupidatat non proident, sunt in culpa qui officia
                  deserunt mollit anim id est laborum
                </p>
                <p className="fst-italic">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <ul>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Ullamco laboris
                    nisi ut aliquip ex ea commodo consequat.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Duis aute irure
                    dolor in reprehenderit in voluptate velit.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Ullamco laboris
                    nisi ut aliquip ex ea commodo consequat. Duis aute irure
                    dolor in reprehenderit in voluptate trideta storacalaperda
                    mastiro dolore eu fugiat nulla pariatur.
                  </li>
                </ul>
              </div>
              <div className="col-lg-4 order-1 order-lg-2 text-center">
                <img
                  src="./img/features-5.svg"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          {/* End Tab Content 5 */}
          <div className="tab-pane" id="tab-6">
            <div className="row gy-4">
              <div className="col-lg-8 order-2 order-lg-1">
                <h3>Reprehit</h3>
                <p>
                  Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis
                  aute irure dolor in reprehenderit in voluptate velit esse
                  cillum dolore eu fugiat nulla pariatur. Excepteur sint
                  occaecat cupidatat non proident, sunt in culpa qui officia
                  deserunt mollit anim id est laborum
                </p>
                <p className="fst-italic">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <ul>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Ullamco laboris
                    nisi ut aliquip ex ea commodo consequat.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Duis aute irure
                    dolor in reprehenderit in voluptate velit.
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" /> Ullamco laboris
                    nisi ut aliquip ex ea commodo consequat. Duis aute irure
                    dolor in reprehenderit in voluptate trideta storacalaperda
                    mastiro dolore eu fugiat nulla pariatur.
                  </li>
                </ul>
              </div>
              <div className="col-lg-4 order-1 order-lg-2 text-center">
                <img
                  src="./img/features-6.svg"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          {/* End Tab Content 6 */}
        </div>
      </div>
    </section>
    {/* End Features Section */}
    {/* ======= Testimonials Section ======= */}
    <section id="testimonials" className="testimonials">
      <div className="container" data-aos="fade-up">
        <div className="testimonials-slider swiper">
          <div className="swiper-wrapper">
            <div className="swiper-slide">
              <div className="testimonial-item">
                <img
                  src="./img/testimonials/testimonials-1.jpg"
                  className="testimonial-img"
                  alt=""
                />
                <h3>Saul Goodman</h3>
                <h4>Ceo &amp; Founder</h4>
                <div className="stars">
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                </div>
                <p>
                  <i className="bi bi-quote quote-icon-left" />
                  Proin iaculis purus consequat sem cure digni ssim donec
                  porttitora entum suscipit rhoncus. Accusantium quam, ultricies
                  eget id, aliquam eget nibh et. Maecen aliquam, risus at
                  semper.
                  <i className="bi bi-quote quote-icon-right" />
                </p>
              </div>
            </div>
            {/* End testimonial item */}
            <div className="swiper-slide">
              <div className="testimonial-item">
                <img
                  src="./img/testimonials/testimonials-2.jpg"
                  className="testimonial-img"
                  alt=""
                />
                <h3>Sara Wilsson</h3>
                <h4>Designer</h4>
                <div className="stars">
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                </div>
                <p>
                  <i className="bi bi-quote quote-icon-left" />
                  Export tempor illum tamen malis malis eram quae irure esse
                  labore quem cillum quid cillum eram malis quorum velit fore
                  eram velit sunt aliqua noster fugiat irure amet legam anim
                  culpa.
                  <i className="bi bi-quote quote-icon-right" />
                </p>
              </div>
            </div>
            {/* End testimonial item */}
            <div className="swiper-slide">
              <div className="testimonial-item">
                <img
                  src="./img/testimonials/testimonials-3.jpg"
                  className="testimonial-img"
                  alt=""
                />
                <h3>Jena Karlis</h3>
                <h4>Store Owner</h4>
                <div className="stars">
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                </div>
                <p>
                  <i className="bi bi-quote quote-icon-left" />
                  Enim nisi quem export duis labore cillum quae magna enim sint
                  quorum nulla quem veniam duis minim tempor labore quem eram
                  duis noster aute amet eram fore quis sint minim.
                  <i className="bi bi-quote quote-icon-right" />
                </p>
              </div>
            </div>
            {/* End testimonial item */}
            <div className="swiper-slide">
              <div className="testimonial-item">
                <img
                  src="./img/testimonials/testimonials-4.jpg"
                  className="testimonial-img"
                  alt=""
                />
                <h3>Matt Brandon</h3>
                <h4>Freelancer</h4>
                <div className="stars">
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                </div>
                <p>
                  <i className="bi bi-quote quote-icon-left" />
                  Fugiat enim eram quae cillum dolore dolor amet nulla culpa
                  multos export minim fugiat minim velit minim dolor enim duis
                  veniam ipsum anim magna sunt elit fore quem dolore labore
                  illum veniam.
                  <i className="bi bi-quote quote-icon-right" />
                </p>
              </div>
            </div>
            {/* End testimonial item */}
            <div className="swiper-slide">
              <div className="testimonial-item">
                <img
                  src="./img/testimonials/testimonials-5.jpg"
                  className="testimonial-img"
                  alt=""
                />
                <h3>John Larson</h3>
                <h4>Entrepreneur</h4>
                <div className="stars">
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                </div>
                <p>
                  <i className="bi bi-quote quote-icon-left" />
                  Quis quorum aliqua sint quem legam fore sunt eram irure aliqua
                  veniam tempor noster veniam enim culpa labore duis sunt culpa
                  nulla illum cillum fugiat legam esse veniam culpa fore nisi
                  cillum quid.
                  <i className="bi bi-quote quote-icon-right" />
                </p>
              </div>
            </div>
            {/* End testimonial item */}
          </div>
          <div className="swiper-pagination" />
        </div>
      </div>
    </section>
    {/* End Testimonials Section */}
    {/* ======= F.A.Q Section ======= */}
    <section id="faq" className="faq">
      <div className="container-fluid" data-aos="fade-up">
        <div className="row gy-4">
          <div className="col-lg-7 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1">
            <div className="content px-xl-5">
              <h3>
                Frequently Asked <strong>Questions</strong>
              </h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis
                aute irure dolor in reprehenderit
              </p>
            </div>
            <div className="accordion accordion-flush px-xl-5" id="faqlist">
              <div
                className="accordion-item"
                data-aos="fade-up"
                data-aos-delay={200}
              >
                <h3 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-1"
                  >
                    <i className="bi bi-question-circle question-icon" />
                    Geographical coverage of project services?
                  </button>
                </h3>
                <div
                  id="faq-content-1"
                  className="accordion-collapse collapse"
                  data-bs-parent="#faqlist"
                >
                  <div className="accordion-body">
                  The Geographical coverage of project services is Syria, Damascus, 29May Street
                  </div>
                </div>
              </div>
              {/* # Faq item*/}
              <div
                className="accordion-item"
                data-aos="fade-up"
                data-aos-delay={300}
              >
                <h3 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-2"
                  >
                    <i className="bi bi-question-circle question-icon" />
                    How does the Project Help you?
                  </button>
                </h3>
                <div
                  id="faq-content-2"
                  className="accordion-collapse collapse"
                  data-bs-parent="#faqlist"
                >
                  <div className="accordion-body">
                  Helping investors to make decisions for their projects.
                  </div>
                </div>
              </div>
              {/* # Faq item*/}
              <div
                className="accordion-item"
                data-aos="fade-up"
                data-aos-delay={400}
              >
                <h3 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-3"
                  >
                    <i className="bi bi-question-circle question-icon" />
                    Are the services of this project safe?
                  </button>
                </h3>
                <div
                  id="faq-content-3"
                  className="accordion-collapse collapse"
                  data-bs-parent="#faqlist"
                >
                  <div className="accordion-body">
                  Yes, because the data in it is protected and encrypted with encryption SSL and licensed.
                  </div>
                </div>
              </div>
              {/* # Faq item*/}
              <div
                className="accordion-item"
                data-aos="fade-up"
                data-aos-delay={500}
              >
                <h3 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-4"
                  >
                    <i className="bi bi-question-circle question-icon" />
                    How can I communicate with the work team?
                  </button>
                </h3>
                <div
                  id="faq-content-4"
                  className="accordion-collapse collapse"
                  data-bs-parent="#faqlist"
                >
                  <div className="accordion-body">
                    <i className="bi bi-question-circle question-icon" />
                    you can communicate with the Work Team in facebook and linkedin and instagram and  twitter.
                  </div>
                </div>
              </div>
              {/* # Faq item*/}
              <div
                className="accordion-item"
                data-aos="fade-up"
                data-aos-delay={600}
              >
                <h3 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-5"
                  >
                    <i className="bi bi-question-circle question-icon" />
                    Tempus quam pellentesque nec nam aliquam sem et tortor
                    consequat?
                  </button>
                </h3>
                <div
                  id="faq-content-5"
                  className="accordion-collapse collapse"
                  data-bs-parent="#faqlist"
                >
                  <div className="accordion-body">
                    Molestie a iaculis at erat pellentesque adipiscing commodo.
                    Dignissim suspendisse in est ante in. Nunc vel risus commodo
                    viverra maecenas accumsan. Sit amet nisl suscipit adipiscing
                    bibendum est. Purus gravida quis blandit turpis cursus in
                  </div>
                </div>
              </div>
              {/* # Faq item*/}
            </div>
          </div>
          <div
            className="col-lg-5 align-items-stretch order-1 order-lg-2 img"
            style={{ backgroundImage: 'url("./img/faq.jpg")' }}
          >
            &nbsp;
          </div>
        </div>
      </div>
    </section>
    {/* End F.A.Q Section */}
    {/* ======= Team Section ======= */}
    <section id="team" className="team">
      <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2>Our Team</h2>
          <p>
            Architecto nobis eos vel nam quidem vitae temporibus voluptates qui
            hic deserunt iusto omnis nam voluptas asperiores sequi tenetur
            dolores incidunt enim voluptatem magnam cumque fuga.
          </p>
        </div>
        <div className="row gy-5">
          <div
            className="col-xl-4 col-md-6 d-flex"
            data-aos="zoom-in"
            data-aos-delay={200}
          >
            <div className="team-member">
              <div className="member-img">
                <img
                  src="./img/team/team-1.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="member-info">
                <div className="social">
                  <a href="">
                    <i className="bi bi-twitter" />
                  </a>
                  <a href="">
                    <i className="bi bi-facebook" />
                  </a>
                  <a href="">
                    <i className="bi bi-instagram" />
                  </a>
                  <a href="">
                    <i className="bi bi-linkedin" />
                  </a>
                </div>
                <h4>Mohammed Al-Kabouni</h4>
                <span>Programmer</span>
              </div>
            </div>
          </div>
          {/* End Team Member */}
          <div
            className="col-xl-4 col-md-6 d-flex"
            data-aos="zoom-in"
            data-aos-delay={400}
          >
            <div className="team-member">
              <div className="member-img">
                <img
                  src="./img/team/team-2.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="member-info">
                <div className="social">
                  <a href="">
                    <i className="bi bi-twitter" />
                  </a>
                  <a href="">
                    <i className="bi bi-facebook" />
                  </a>
                  <a href="">
                    <i className="bi bi-instagram" />
                  </a>
                  <a href="">
                    <i className="bi bi-linkedin" />
                  </a>
                </div>
                <h4>Dr.Haydar Abdalla</h4>
                <span>Project Supervisor</span>
              </div>
            </div>
          </div>
          {/* End Team Member */}
          <div
            className="col-xl-4 col-md-6 d-flex"
            data-aos="zoom-in"
            data-aos-delay={600}
          >
            <div className="team-member">
              <div className="member-img">
                <img
                  src="./img/team/team-3.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="member-info">
                <div className="social">
                  <a href="">
                    <i className="bi bi-twitter" />
                  </a>
                  <a href="">
                    <i className="bi bi-facebook" />
                  </a>
                  <a href="">
                    <i className="bi bi-instagram" />
                  </a>
                  <a href="">
                    <i className="bi bi-linkedin" />
                  </a>
                </div>
                <h4>Anas AL-Sibai</h4>
                <span>Researcher</span>
              </div>
            </div>
          </div>
          {/* End Team Member */}
        </div>
      </div>
    </section>
    {/* End Team Section */}
  </main>
  {/* End #main */}
<Footer/>
        </div>
    );
};

export default MainPage;